import { render } from "./Institute.vue?vue&type=template&id=465e5a0c&scoped=true"
import script from "./Institute.vue?vue&type=script&lang=js"
export * from "./Institute.vue?vue&type=script&lang=js"

import "./Institute.vue?vue&type=style&index=0&id=465e5a0c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-465e5a0c"

export default script